import ReactSwitch from 'react-switch';

function ToggleButton({ name, value, onChange, context }) {
    return (
        <ReactSwitch
            id={`${context}-${name}`}
            checked={value}
            onChange={(checked) => onChange({ target: { name, checked } })}
            onColor="#52c91e"
            offColor="#ccc"
            uncheckedIcon={false}
            checkedIcon={false}
        />
    );
}

export default ToggleButton;
